import { SidebarViewState } from 'apps/aiAutomation/components/Layout/lib/types'
import { SIDEBAR_VIEW_TYPES_LIST, SidebarViewType } from 'apps/aiAutomation/lib/sidebar'
import {
  AiAutomationLayoutState,
  ViewPayload,
  ViewPayloadMap,
} from 'apps/aiAutomation/store/layout/types'

export const getViewsStateDefaults = () =>
  SIDEBAR_VIEW_TYPES_LIST.reduce((result, view) => {
    result[view] = 'closed'

    return result
  }, {} as Record<SidebarViewType, SidebarViewState>)

export const getViewsPayloadDefaults = () =>
  SIDEBAR_VIEW_TYPES_LIST.reduce((result, view) => {
    result[view] = null

    return result
  }, {} as ViewPayloadMap)

export const setViewPayload = (state: AiAutomationLayoutState, payload: ViewPayload) => {
  if ('payload' in payload) {
    state.viewPayload[payload.view] = (payload.payload ?? null) as TSFixMe
  } else {
    state.viewPayload[payload.view] = null
  }
}
